import type { ComponentType } from "react";
import { Registry } from "scantling-common";

export interface OverviewPane {
  type: string;
  order: number;
  title: string;
  content: ComponentType;
}

export const overviewRegistry = new Registry<OverviewPane>();

export function getOverviewPanes(): OverviewPane[] {
  return overviewRegistry.getAll().sort((a, b) => a.order - b.order);
}
